import { useTheme } from '@emotion/react';
import React, { JSX } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import {
  GroupBase,
  OptionsOrGroups,
  PropsValue,
  StylesConfig as ReactSelectStyles
} from 'react-select';
import { SelectProps } from '../Select/Select';
import { DataTestIdProp } from '../../../../Models/DataTestIdProp';

interface LoadOptionsResponse<Option> {
  options: Option[];
  hasMore: boolean;
  additional?: boolean;
}

interface Props<Option> {
  loadOptions: (
    search: string,
    prevOptions: OptionsOrGroups<Option, GroupBase<Option>>
  ) => Promise<LoadOptionsResponse<Option>>;
  className?: string;
  defaultOptions?: boolean | OptionsOrGroups<Option, GroupBase<Option>>;
}

function SelectAsyncPaginate<Option>(
  props: Props<Option> & SelectProps<Option> & DataTestIdProp
): JSX.Element {
  const theme = useTheme();

  const {
    getLabel,
    getValue,
    id,
    isClearable,
    loadOptions,
    onChange,
    placeholder,
    selectedOption,
    dataTestId,
    menuPortalTarget,
    menuIsOpen,
    onFocus,
    onBlur,
    inputValue,
    setInputValue,
    className,
    defaultOptions
  } = props;

  return (
    <span className={className || ''} data-testid={dataTestId}>
      <AsyncPaginate
        debounceTimeout={300}
        defaultOptions={defaultOptions}
        loadOptions={loadOptions}
        theme={theme.reactSelectTheme}
        styles={theme.reactSelectStyles as ReactSelectStyles<Option>}
        isClearable={isClearable}
        value={selectedOption}
        onChange={(option: PropsValue<Option>): void => onChange(option as Option)}
        getOptionValue={getValue}
        formatOptionLabel={getLabel}
        placeholder={placeholder}
        id={id}
        classNamePrefix="select"
        menuPortalTarget={menuPortalTarget}
        menuIsOpen={menuIsOpen}
        onFocus={onFocus}
        onBlur={onBlur}
        inputValue={inputValue}
        onInputChange={setInputValue}
      />
    </span>
  );
}

export default SelectAsyncPaginate;
